import React, { useState, useEffect } from "react";
import { Button, TextField, InputAdornment } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../assets/Logo_Sevenly.png";
import background from "../assets/background.png";
import loaderGif from "../assets/sevenly-loader.gif";
import Axios from "../axios";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import Avatar from "@mui/material/Avatar";
import { grey } from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const SetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfimrPassword, setShowConfirmShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const emailParam = queryParams.get("email");
    if (emailParam) {
      setEmail(emailParam);
    } else {
      toast.error("Invalid or missing email in URL.");
    }
  }, [location.search]);

  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);
  const handleOtpChange = (e) => setOtp(e.target.value);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmShowPassword(!showConfimrPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword || !otp) {
      toast.error("All fields are required.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setLoader(true);

    const data = {
      email: email,
      password: password,
      confirmPassword: confirmPassword,
      otp: otp,
    };

    try {
      const response = await Axios.post(
        process.env.REACT_APP_BACKEND + "reset-password",
        data
      );
      toast.success(response.data.message);
      navigate("/");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to set the password."
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <div
      className="container-fluid"
      style={{
        width: "100vw",
        height: "100vh",
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      {loader ? (
        <div className="position-absolute top-50 start-50 translate-middle">
          <img src={loaderGif} alt="Loading..." />
        </div>
      ) : (
        <div className="position-absolute top-50 start-50 translate-middle bg-white p-4 rounded shadow login_box sevenlycard">
          <div className="log_form col-lg-12">
            <div className="d-flex justify-content-center align-items-center col-lg-6">
              <Avatar
                sx={{ bgcolor: grey[200], width: 250, height: 250 }}
                className="mx-4"
              >
                <img src={logo} className="login_logo" alt="logo" />
              </Avatar>
            </div>
            <div className="mt-2 mx-4 flex justify-content-center align-items-center col-lg-6 p-5">
              <h1 className="mb-4 mt-2">Set Your Password</h1>
              <TextField
                label="Email"
                fullWidth
                variant="standard"
                value={email}
                disabled
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Password"
                type={showPassword ? "text" : "password"}
                fullWidth
                variant="standard"
                value={password}
                onChange={handlePasswordChange}
                className="mt-4"
                placeholder="********"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Confirm Password"
                type={showConfimrPassword ? "text" : "password"}
                fullWidth
                variant="standard"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                className="mt-4"
                placeholder="********"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={toggleConfirmPasswordVisibility}>
                        {showConfimrPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="OTP"
                fullWidth
                variant="standard"
                value={otp}
                onChange={handleOtpChange}
                className="mt-4"
                placeholder="Enter 4-digit OTP"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <div className="text-center mt-5">
                <Button
                  type="submit"
                  variant="contained"
                  className="w40 fs-12 sevenly-btn"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SetPassword;
